import React from "react";
import Typed from "react-typed";

export const Herox = () => {
  return (
    <>
      <div class="hero min-h-16 bg-base-200">
        <div class="hero-content flex-col lg:flex-row-reverse">
          <img src="/tamim.png" class="lg:max-w-sm rounded-lg shadow-2xl " />
          <div>
            <div class="mockup-code">
              <pre data-prefix="$">
                <code>
                  <Typed
                    className="lg:text-4xl"
                    strings={["Abdulla Al Shahid"]}
                    typeSpeed={40}
                  />
                </code>
              </pre>
              <pre data-prefix=">" class="text-warning">
                <code>
                  <Typed
                    className="lg:text-2xl"
                    strings={[
                      "Full Stack Developer",
                      "Mongo DB",
                      "Express JS",
                      "React JS",
                      "Node JS",
                    ]}
                    typeSpeed={70}
                    loop
                  />
                </code>
              </pre>
            </div>
            <p class="py-4 text-justify w-60 lg:py-6 lg:text-justify lg:w-auto ">
              Hi i m shahid , fan of photography, technology and love to create
              new things through code.I have developed more than 7+ full stack
              projects. I can build and customize your website according to your
              needs and expectations. I always try to keep updating my
              programming knowledge to build myself as an efficient web
              developer.
            </p>
            <button class="btn btn-primary">Resume</button>
          </div>
        </div>
      </div>
    </>
  );
};
